import React, { Component } from 'react';
import ErrorTooltip from 'components/snippets/errorTooltip';
import moment from 'moment';
import HotelsWithFilter from 'components/widgets/autocompletes/hotelsWithFilter';
import Chains from 'components/widgets/autocompletes/chains';
import CustomDatePicker from 'components/widgets/customDatePicker';
import Lang from 'libraries/Lang';

class HotelSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldValidate: true,
            commonDateFormat: props.commonDateFormat,
            unicaId: null
        };
        //        this.state = stateValue;
        //      this.selectDestination = this.selectDestination.bind(this);
        this.setHotel = this.setHotel.bind(this);
        this.onCustomDatesChange = this.onCustomDatesChange.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.selectHotel = this.selectHotel.bind(this);
        this.selectChain = this.selectChain.bind(this);

        this.onCustomDateChange = this.onCustomDateChange.bind(this);
        this.onCustomCheckOutDateChange = this.onCustomCheckOutDateChange.bind(this);

        this.onCheckInDateChange = this.onCheckInDateChange.bind(this);
        this.onCheckOutDateChange = this.onCheckOutDateChange.bind(this);
    }
    
    setHotel(event) {
        const { value } = event.target;
        this.props.setSearchParameter('hotel', value);
    }

    selectHotel(selectedHotel) {
        // const { shouldValidate } = this.state;
        // if (shouldValidate) {
        //     this.errorHandler.checkRule('form.departure', selectedDeparture);
        // }
        //  this.setState({ selectedDeparture });
        if(selectedHotel != null) {
            let unicaId = selectedHotel.id
            this.setState({unicaId})
            const eanData = this.getHotelDetail(selectedHotel.id, 'H');
            eanData.then((data) => {
                this.props.setSearchParameter('eanData', data);
            });
        } else {
            this.props.setSearchParameter('eanData', null);
        }
        this.props.setSearchParameter('selectedHotel', selectedHotel);
    }
  
    getHotelDetail(hotelId, type) {
      
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.open('GET', `/api/autocompletes/hotel-detail/${hotelId}/${type}`);

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    const data = JSON.parse(xhr.response);
                    resolve(data);
                } else {
                    console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
                }
            };
            xhr.onerror = () => {
                console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            };
            xhr.send();
        });
    }

    selectChain(selectedChain) {
        const { hotelData } = this.props;
        const { selectedHotel } = hotelData;
        if(selectedChain != null && selectedHotel != null) {
            const eanData = this.getHotelDetail(selectedChain.id, 'C');
            eanData.then((data) => {
                this.props.setSearchParameter('eanData', data);
            });
        }
        this.props.setSearchParameter('selectedChain', selectedChain);
    }

    onCustomDatesChange(name, depDate) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.props.errorHandler.checkRule('form.dates', { depDate });
            this.props.errorHandler.clear('form.dates');
        }

        depDate = moment(depDate, 'MM/DD/YYYY', true).isValid() ? moment(depDate) : depDate;

        this.props.setSearchParameter(name, depDate);
    }

    onDatesChange(checkInDate, checkOutDate) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.props.errorHandler.clear('form.hotelDates');
        }

        this.props.setSearchParameter('checkInDate', checkInDate);
        this.props.setSearchParameter('checkOutDate', checkOutDate);
    }

    onCheckInDateChange(checkInDate) {
        const { shouldValidate } = this.state;
        const { hotelData } = this.props;

        const checkOutDate = hotelData?.checkOutDate;

        if (shouldValidate && checkOutDate != null) {
            this.props.errorHandler.checkRule('form.hotelDates', { checkInDate, checkOutDate });

            //            this.props.errorHandler.clear('form.hotelDates');
        }
        this.props.setSearchParameter('checkInDate', checkInDate);
    }

    onCheckOutDateChange(selectedcheckOutDate) {
        const { shouldValidate } = this.state;
        const { hotelData } = this.props;
        const checkOutDate = selectedcheckOutDate;
        const { checkInDate } = hotelData;
        if (shouldValidate) {
            this.props.errorHandler.checkRule('form.hotelDates', { checkInDate, checkOutDate });

            //            this.props.errorHandler.clear('form.hotelDates');
        }
        this.props.setSearchParameter('checkOutDate', selectedcheckOutDate);
    }

    onCustomDateChange(checkInDate) {
        checkInDate = moment(checkInDate, this.props.commonDateFormat, true).isValid() ? moment(checkInDate, 'DD-MMM-YYYY') : checkInDate;
        this.props.setSearchParameter('checkInDate', checkInDate);
    }

    onCustomCheckOutDateChange(checkOutDate) {
        checkOutDate = moment(checkOutDate, this.props.commonDateFormat, true).isValid() ? moment(checkOutDate, 'DD-MMM-YYYY') : checkOutDate;

        const { hotelData } = this.props;
        const { checkInDate } = hotelData;
        if (moment(checkOutDate, 'MM/DD/YYYY', true).isValid()) {
            this.props.errorHandler.checkRule('form.hotelDates', { checkInDate, checkOutDate });
            //            this.props.errorHandler.clear('form.hotelDates');
        }

        this.props.setSearchParameter('checkOutDate', checkOutDate);
    }

    render() {
        const {
            hotel, checkInDate, checkOutDate, selectedHotel,
            selectedChain,
            selectedDestination,
            selectedProducts,
        } = this.props.hotelData;

        const { activeTab } = this.props;
        const { commonDateFormat } = this.props;

        console.log('this.props.selectedDest', selectedDestination);
        const isCheckInDateValid = moment(checkInDate, 'MM/DD/YYYY', true).isValid();
        const isCheckOutDateValid = moment(checkOutDate, 'MM/DD/YYYY', true).isValid();

        const { errors } = this.props;
        const  unicaId   = (selectedDestination != null && selectedDestination.unicaId != undefined) ? selectedDestination.unicaId : this.state.unicaId ;
        
        return (

            <div className="">
                {/* <div className="font-weight-bold text-dark mb-2">Hotel</div> */}
                <div className="tab-pane active in">
                    <div className="row gutter-10 align-items-center">
                        <div className={'col-12 col-md-6 ' + selectedProducts && selectedProducts == 'FH' ? 'col-lg-3' : 'col-lg-6'}>

                            <div className="element-container">
                                <label className="text-label" htmlFor="hotel">{Lang.trans('engine.hotel')}</label>

                                <HotelsWithFilter
                                    id="hotel"
                                    placeholder={Lang.trans('engine_travelgenie.hotel_placeholder')}
                                    onSelect={this.selectHotel}
                                    value={selectedHotel}
                                    city={selectedDestination?.city}
                                    longitude={selectedDestination?.longitude}
                                    latitude={selectedDestination?.latitude}
                                    radius={selectedDestination?.radius}
                          />
                            </div>
                        </div>

                        <div className={'col-12 col-md-6 ' + selectedProducts && selectedProducts == 'FH' ? 'col-lg-3' : 'col-lg-6'}>
                            <div className="element-container">
                                <label className="text-label" htmlFor="chain">{Lang.trans('engine_travelgenie.chain')}</label>

                                <Chains
                                    id="chain"
                                    placeholder={Lang.trans('engine_travelgenie.chain_placeholder')}
                                    onSelect={this.selectChain}
                                    value={selectedChain}
                                    unicaId={unicaId}
                                    longitude={selectedDestination?.longitude}
                                    latitude={selectedDestination?.latitude}
                                    radius={selectedDestination?.radius}
                                />
                            </div>
                        </div>
                        {selectedProducts && selectedProducts == 'FH'
                            ? (
                                <>
                                    <div className="col-6 col-md-6 col-lg-3">
                                        <div className="element-container range-picker-container">
                                            <CustomDatePicker
                                                onCustomDateChange={this.onCustomDateChange}
                                                dateId="checkInDate"
                                                onDateChange={this.onCheckInDateChange}
                                                minDate={1}
                                                label={Lang.trans('engine_hotels.depart')}
                                                datePlaceholderText={Lang.trans('engine.date_format')}
                                                date={checkInDate}
                                                isStartDateValid={isCheckInDateValid}
                                                activeTab={activeTab}
                                                dateFormat={commonDateFormat}
                                            />

                                            {errors.form && errors.form.checkInDate && (
                                                <ErrorTooltip error={{ message: errors.form.checkInDate, id: 'checkInDate' }} />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-6 col-lg-3">
                                        <div className="element-container range-picker-container">

                                            <CustomDatePicker
                                                onCustomDateChange={this.onCustomCheckOutDateChange}
                                                dateId="checkOutDate"
                                                onDateChange={this.onCheckOutDateChange}
                                                minDate={1}
                                                label={Lang.trans('engine_hotels.return')}
                                                datePlaceholderText={Lang.trans('engine.date_format')}
                                                date={checkOutDate}
                                                isStartDateValid={isCheckOutDateValid}
                                                activeTab={activeTab}
                                                dateFormat={commonDateFormat}
                                            />

                                            {errors.form && errors.form.hotelDates && (
                                                <ErrorTooltip error={{ message: errors.form.hotelDates, id: 'hoteldates' }} />
                                            )}
                                        </div>
                                    </div>
                                </>
                            )
                            : null}
                    </div>
                </div>
            </div>

        );
    }
}

export default HotelSearch;
